
async function handleJsonResponse(res) {
  let data = null;

  try {
    data = await res.json();
  } catch {
    data = null;
  }

  if (!res.ok) {
    const message =
      data?.detail ||
      data?.message ||
      data?.error ||
      "Failed to submit intake.";
    throw new Error(message);
  }

  return data;
}

export async function getPlan() {
  const res = await fetch("/py/plans", {
    method: "GET",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
    },
  });

  return handleJsonResponse(res);
}

export async function getTodayPlan() {
  const res = await fetch("/py/plans/today", {
    method: "GET",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
    },
  });

  return handleJsonResponse(res);
}

export async function getPlanByDate(date) {
  const res = await fetch(`/py/plans/by-date?date=${date}`, {
    method: "GET",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
    },
  });

  return handleJsonResponse(res);
}
export async function getSessionById(sessionId) {
  const res = await fetch(`/py/sessions/${sessionId}`, {
    method: "GET",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
    },
  });

  if (!res.ok) {
    let message = "Failed to load session";
    try {
      const data = await res.json();
      message = data?.detail || message;
    } catch (_) {}
    throw new Error(message);
  }


  return handleJsonResponse(res);
}

export async function connectToPlanByPublicId(publicId) {
  const res = await fetch("/py/plans/connect", {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      public_id: publicId,
    }),
  });

  return handleJsonResponse(res);
}

export async function completeSessionExercise(sessionExerciseId, completed = true) {
  const res = await fetch(`/py/sessions/exercises/${sessionExerciseId}/complete`, {
    method: "PATCH",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ completed }),
  });

  if (!res.ok) {
    let message = "Failed to update exercise progress";
    try {
      const data = await res.json();
      message = data?.detail || message;
    } catch (_) {}
    throw new Error(message);
  }

  return res.json();
}

export async function getSessionHistory() {
  const res = await fetch("/py/sessions/history", {
    method: "GET",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
    },
  });

  return handleJsonResponse(res);
}